import { render, staticRenderFns } from "./adminComments.vue?vue&type=template&id=dcfabc24&scoped=true&"
import script from "./adminComments.vue?vue&type=script&lang=js&"
export * from "./adminComments.vue?vue&type=script&lang=js&"
import style0 from "./adminComments.vue?vue&type=style&index=0&id=dcfabc24&lang=scss&scoped=true&"
import style1 from "./adminComments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfabc24",
  null
  
)

export default component.exports